import { render, staticRenderFns } from "./FormContentComponent.vue?vue&type=template&id=98f2e8de&scoped=true"
import script from "./FormContentComponent.vue?vue&type=script&lang=js"
export * from "./FormContentComponent.vue?vue&type=script&lang=js"
import style0 from "./FormContentComponent.vue?vue&type=style&index=0&id=98f2e8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f2e8de",
  null
  
)

export default component.exports